// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"33c060eb","865":"07df8cf4"}[chunkId] + ".chunk.js";
};